import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/_services/auth.service';
import { LoaderService } from 'app/_services/loader.service';
import { locationUpdata } from './location.model';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { process, State } from '@progress/kendo-data-query';
import moment = require('moment');
import { FormControl, FormGroup } from '@angular/forms';
import { utils, WorkBook, write } from 'xlsx';
import { environment } from '.../../environments/environment';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Color } from '@progress/kendo-drawing';
import { LegendComponentGenerated } from '@progress/kendo-angular-charts';


declare var $: any;
declare var google: any;
declare var firebase: any;
declare var MapLabel: any;
var stopAnimation = true;

declare const MarkerClusterer;

@Component({
  selector: 'LocationMgt',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css']
})
export class LocationMgt implements OnInit{
    authtoken: any;
    allUsers: any;
    currentDateModal:any;
    prjID: string;
    userLocations:any;
    public ZoneData : any ;
    public WardData : any ;
    dropdownListName : any;
    dropdownListId : any;
    dropdownListWardName : any;
    dropdownListWardId : any;
    loactionDoc: AngularFirestoreDocument<locationUpdata>;
    jsonData: locationUpdata;
    selectedItems : any;
    dropdownSettings = {};
    public state: State = { 
      skip: 0,
      take: 15,  
      filter: { 
        logic: 'and',
        filters: []
      }
    };
    showLoader: boolean;
    countData: { TOTAL: number; RUNNING: number; NOT_STARTED: number; STOPPED: number; WORKING: number; NOTWORKING: number; OFFLINE: number; TOTALRUNNING: number; DATA_NOT_RECEIVED: number; VTSINSTALLED: number; VTSNOTINSTALLED: number; MAINTENANCE: number; STANDBY: number; };
    zonesList: { name: string; count: number; }[];
    isSuperAdmin: boolean;
  gridDataUserList: any;
  selectedDate: any;
  route: google.maps.Polyline;
  allVehiclesData: any;
  markerCluster: any;
  routePath: any[];
  LType : any[];
  map: any;
  polygondData: any;
  allMarkers: any;
  markerStart: any;
  markerEnd: any;
  ZoneList: { id: number; itemName: string; }[];
  WardList: { id: number; itemName: string; }[];
  basicExampleSettings: { text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; classes: string; };
  arr: any[];
  public uname: any;
  public Zname: any;
  public Wname: any;
  dvalue = false;
  svalue = false;
  updateId: any;
  public C_ZName: any;
  public C_Wname: any;
  public C_Uname: any;

  defaultStartDate: any;
  defaultEndDate: any;
  dataRangeModal:any;
  startDate: any;
  endDate: any;
 
  updateSuccess: any;
  public Wardid: string;
  F_Point: void;
  L_point: any;
  userID: any ;
 
    constructor(
        private loaderService: LoaderService,
        private auth: AuthService,
        private http: HttpClient,
        public afs: AngularFirestore,
      ) { 


        this.authtoken = JSON.parse(localStorage.getItem('authData'));
        this.prjID = this.auth.getAuthentication().projectId;


        this.userID =  this.auth.getAuthentication().id  ;


        console.log('113',this.userID);
        



        var date = new Date();   
        this.currentDateModal=date;
        this.loaderService.status.subscribe((val: boolean) => {
          this.showLoader = val;
        });

        var firstDay = new Date();
        var lastDay = new Date();
        this.dataRangeModal = { beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() }, endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() } };

        this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
        this.defaultEndDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();

      
      }


    public async pulliSwmRecords  () {

        this.loaderService.display(true);
        this.allUsers = [];

         this.afs.firestore.collection('iSWM').doc('device_details').collection('permission_and_usertype').get().then((querySnapshot) => { 
           querySnapshot.forEach((doc) => {
           
             if(this.userID == 19 ){

              this.allUsers.push({
                'docId':doc.id,
                'userName':doc.data().userName,
                'userPhone':doc.data().userPhone,
                'user_type':doc.data().user_type
                })
             }else if(doc.data().user_type !== 'HO'){

              this.allUsers.push({
                'docId':doc.id,
                'userName':doc.data().userName,
                'userPhone':doc.data().userPhone,
                'user_type':doc.data().user_type
                })

             }

         
             
            
             

             }
           )
           this.loaderService.display(false);
        })
  
        this.gridDataUserList = process(this.allUsers, this.state);   


        
 
       
    }


      public async pulliSwmUserLocationRecords(phone) {
       
          console.log('test');
          
        this.afs.collection('iSWM').doc('locations').collection(
          'active_locations', 
          ref=>ref.where('createdDate','==',this.startDate  ).where('phone','==',phone.userPhone).orderBy('dateTime', 'desc')
        ).valueChanges().subscribe( async (val) => {
             
              this.userLocations = await val;
              var length =  val.length-1

              var len = val.length

              // this.F_Point = this.userLocations[0].dateTime
              // this.L_point = this.userLocations[length].dateTime

               if(length>0){


                $('#viewRoute').modal('show');
               
                var myOptions = {
                  center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
                  zoom: 13,
                  panControl: true,
                  mapTypeControl: true,
                  mapTypeId: google.maps.MapTypeId.ROADMAP,
                  mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                    position: google.maps.ControlPosition.TOP_LEFT
                  },
                  zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM,
                    style: google.maps.ZoomControlStyle.SMALL
                  },
                  // fullscreenControlOptions: {
                  //   position: google.maps.ControlPosition.TOP_CENTER,
                  //   style: google.maps.ControlPosition.SMALL
                  // }
            
                };
        
                
               this.map = new google.maps.Map(document.getElementById('map'), myOptions);

                this.createRoute(this.userLocations);
          
               }else {
                    alert('data not found')

                   
               }
           
            
         }
        ) ;
        
      }

      orgValueChange(date){ 
         var changeDate = moment(date).format('YYYY-MM-DD');
         this.startDate  = changeDate;

     }

    plotStartAndEndPoint(endPoint, type) {
      
        //var start = new google.maps.LatLng(startPoint.latitude, startPoint.longitude);
        var end = new google.maps.LatLng(endPoint.latitude, endPoint.longitude);
        this.markerStart = new google.maps.Marker({
            position: end,
            map: this.map,
            icon:  type == 'start' ?  'assets/img/start.png' : 'assets/img/end.png',
    
            labelClass: 'labels', // the CSS class for the label
            labelStyle: { opacity: 0.0 }
        });
        
        this.map.setZoom(18);

        this.map.panTo(this.markerStart.position);
      }

    createRoute(pathCoords) {

      console.log(pathCoords);
      

        var i;
        var polyCords = [];
        var startNum, endNum;
        
        for (i = 0; i < pathCoords.length; i++) {
          
             
            if(i==0)
              {
                endNum = (pathCoords[i]);
                this.plotStartAndEndPoint( endNum, 'start');
              }
              if(i==pathCoords.length-1)
              {
                endNum = (pathCoords[i]);
                this.plotStartAndEndPoint( endNum, 'current');
              }
          
            //polyCords.push({ lat:parseFloat( pathCoords[i].latitude), lng: parseFloat(pathCoords[i].longitude) });
             
        }

         
        var car =
            'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';
        var icon = {
            path: car,
            scale: 1,
            strokeColor: 'white',
            strokeWeight: 0.1,
            fillOpacity: 5,
            fillColor: '#35370C',
            offset: '2%',
            // rotation: parseInt(heading[i]),
            anchor: new google.maps.Point(10, 25) // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
        };
        this.routePath = polyCords;
         this.route = new google.maps.Polyline({
            path: polyCords,
            strokeColor: '#9110c4',
            strokeOpacity: 4.0,
            strokeWeight: 5,
          
            map: this.map
        });
    }

       




      
  renoveAllMarker() {
       if (this.allMarkers.length > 0) {
           for (var i = 0; i < this.allMarkers.length; i++) {
              this.allMarkers[i].setVisible(false);
         }
       }
  }

  ngOnInit() {

        this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
        this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
        
        var authData = JSON.parse(localStorage.getItem('authData'))
    
        if(authData.id == 19 || authData.id == 445){
          this.isSuperAdmin = true
        }
        else {
          this.isSuperAdmin = false
        }
        this.pulliSwmRecords();

        
   


        
       this.getZonedata();
       this.getWarddataIswm(0);

       this.basicExampleSettings = { 
              text:"Select Countries",
              selectAllText:'Select All',
              unSelectAllText:'UnSelect All',
              enableSearchFilter: true,
              classes:"myclass custom-class"
            }; 

       // this.loaderService.display(false);


      
  }

      ngOnDestroy(){
        // if (this.subscription){
        //     this.subscription.unsubscribe();
        // }
      }


      importVehiclesExcelReport(data) {
        const ws_name = 'VehicleReport';
        const wb: WorkBook = { SheetNames: [], Sheets: {} };
        const ws: any = utils.json_to_sheet(data);
        wb.SheetNames.push(ws_name);
        wb.Sheets[ws_name] = ws;
        const wbout = write(wb, {
          bookType: 'xlsx', bookSST: true, type:
            'binary'
        });
        saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
      }
    
      s2ab(s) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) {
          view[i] = s.charCodeAt(i) & 0xFF;
        };
        return buf;
      }

      async  getZonedata() {
          await this.http.get(environment.apiUrl + 'admin/getAllZone').subscribe((data)=>{
              
             this.ZoneData = data

             let obj = { ID: 'All',ENTITYNAME:'ALL' };
             this.ZoneList = [...this.ZoneData, obj];
             
             

          })   
        
       }
      
       async getWarddataIswm(Zname) {
        await this.http.get(environment.apiUrl + 'admin/getAllWardIswm?Wardid=' + Zname).subscribe((data)=>{
              
          this.WardData = data

          let obj = { ID: 'All',WARD:'ALL' };
          this.WardList = [...this.WardData, obj];
          

        })  
     
      }
 


         



      Update(item){
        this.Zname = null;
        this.Wname = null;
        this.uname = null;

        this.dropdownListName = [];
        this.dropdownListId = [];


        this.dropdownListWardName = [];
        this.dropdownListWardId = [];
      

        

        this.LType =  [
          { id: 'HO', name: 'Ho' },
          { id: 'TRACK_MANAGER', name: 'Track Manager' },
          { id: 'ZONE_MANAGER', name: 'Zone Manager' },
          { id: 'WARD_MANAGER', name: 'Ward Manager' },
          { id: 'OPERATIONS_MANAGER', name: 'Operations Manager' },

        ] 
        
        $('#updateRoute').modal('show');

        this.updateId = item
        

      

        

      }

 

      allSelectZone(event){

          if(event.ID =='All'){


            console.log('439',event.ID );
            
           this.Wname ='All'
        
           this.dvalue = true ;

          this.dropdownListName= [] ;

          this.dropdownListId = [] ;

          this.dropdownListWardName= [] ;

          this.dropdownListWardId = [] ;


          }else{

            this.dvalue = false ;
             //console.log('404',event.ID );
             
                var Zid = this.dropdownListId.includes(event.ID)

                if( !Zid  ){
                this.dropdownListName.push(event.ENTITYNAME) ;
                this.dropdownListId.push(event.ID) ;
              }


          }
     

         console.log('474', this.dropdownListId.toString());

         this.getWarddataIswm(this.dropdownListId.toString())
         


                // check for include
                // ......


        //  var Zid = this.dropdownListId.includes(event.ID)

        //  if( !Zid  ){
        //         this.dropdownListName.push(event.ENTITYNAME) ;
        //         this.dropdownListId.push(event.ID) ;
        //       }

   
        // if(event.ID == 'ALL'){

        //   //// clear function:  dropdownListName
        //   // clear function: all form clear
        //   // zoneSelect & wards values
        //   // update Click

        //   this.dropdownListName = null ;

        //   this.dropdownListId  = [] ;


        //   this.dropdownListName.push(event.ENTITYNAME) ;
        //   this.dropdownListId.push(event.ID) ;

        //    this.Wname ='ALL'
        //    this.Zname ='ALL'
        //    this.dvalue = true ;

        // }else{





        //   this.dvalue = false ;
        //   this.Wname =''

        // }

      
        
      }

      allSelectWard(event){

      

        var Wid = this.dropdownListWardId.includes(event.ID)
        

        if( !Wid  ){
             this.dropdownListWardName.push(event.WARD) ;
             this.dropdownListWardId.push(event.ID) ;
        }

      
        
      }


      updateInFire(){ 

      

        if (this.uname == null || this.uname == undefined || this.uname == "" || this.uname == "null"){
          this.C_Uname  = true; 
          return 
        }

        if (this.Zname == null || this.Zname == undefined || this.Zname == "" || this.Zname == "null"){
          this.C_ZName  = true; 
          return 
        }

        if (this.Wname == null || this.Wname == undefined || this.Wname == "" || this.Wname == "null"){
          this.C_Wname  = true; 
          return 
        }


        this.C_ZName  = false;
        this.C_Wname  = false;
        this.C_Uname  = false; 
       
            

          if(this.Zname == 'All'){  
              
            
            this.Zname ;
            this.Wname ;
            this.uname;


           // console.log(this.Zname,this.Wname ,this.uname);


           
           this.afs.firestore.collection('iSWM')
           .doc('device_details')
           .collection('permission_and_usertype')
           .doc(this.updateId)
           .update({

             'user_type' : this.uname,
             'ward' :this.Wname,
             'zone' :  this.Zname

           }).then((new_doc)=>{
                  console.log('586',new_doc);
                  
             })
             .catch((err)=>{
                 console.log('568',err);
                
             }).then(()=>{
              this.updateSuccess = true
              setTimeout(() => {
                  $("#updateRoute").modal("hide");

                  
                  this.pulliSwmRecords()
                 this.editmessage()
                }, 2000);
              
         })
         .catch((err)=>{
             console.log('568',err);
            
         });





           

            

         
          }else{

           // this.ward =  this.dropdownListWardId.toString()

            this.afs.firestore.collection('iSWM')
            .doc('device_details')
            .collection('permission_and_usertype')
            .doc(this.updateId)
            .update({

              'user_type' : this.uname,
              'ward' :this.dropdownListWardId.toString(),
              'zone' : this.dropdownListId.toString()

            }).then(()=>{
              this.updateSuccess = true
              setTimeout(() => {
                  $("#updateRoute").modal("hide");

                  
                  this.pulliSwmRecords()
                 this.editmessage()
                }, 2000);
              
         })
         .catch((err)=>{
             console.log('568',err);
            
         });








            // this.jsonData.user_type = this.uname;
            // var Zname = this.dropdownListName.toString()
            //this.jsonData.zone = this.dropdownListId.toString()
            //var wname = this.dropdownListWardName.toString()
            //this.jsonData.ward =  this.dropdownListWardId.toString()



            // console.log('546', this.jsonData.user_type,'5466',this.uname);
            
    


             //console.log(Zname,Zid,wname,wid,userType);


            //  var query = ` update set ${'"'+Zid+'"'} ${'"'+wid+'"'} ${userType}  ${this.updateId} ` 


            //  console.log(query);


          //    this.afs.collection('iSWM')
          //    .doc('device_details')
          //    .collection('permission_and_usertype')
          //    .doc(this.updateId)
          //    .update(
          //       {
          //         'userType' : userType                 

          //       }

          //    ).then((new_doc)=>{
          //      console.log(new_doc);
               
          // })
          // .catch((err)=>{
          //     console.log('568',err);
             
          // });
              

          // console.log(this.updateId);
          

          //  this.loactionDoc =  this.afs.collection('iSWM')
          // .doc('device_details')
          // .collection('permission_and_usertype')
          // .doc(this.updateId)


          // this.loactionDoc.update(this.jsonData)


          // console.log('580',result);
          


          // const ORDER_ITEMS = this.afs.collection('iSWM')
          // .doc('device_details')
          // .collection('permission_and_usertype')

          //    ORDER_ITEMS.where('id', '==', 2)
          //    .get()
          //    .then(snapshots => {
          //     if (snapshots.size > 0) {
          //     snapshots.forEach(orderItem => {
          //     ORDER_ITEMS.doc(orderItem.id).update({ status: 1 })
          //        })
          //    }
          // })


            
             
          


          }
          
        
      }


      delete(item,type){

        if(type == 'zone'){
          var len = this.dropdownListName.length 

          for (let index = 0; index < len; index++) {
            const element =  this.dropdownListName[index];
 
            if(element == item ){
              console.log('454',index);
              
             this.dropdownListName.splice(index,1)
             this.dropdownListId.splice(index,1)
            }
           
          }
         
    
        }else{ 
          var len = this.dropdownListWardName.length 

          for (let index = 0; index < len; index++) {
            const element =  this.dropdownListWardName[index];
 
            if(element == item ){
             this.dropdownListWardName.splice(index,1)
             this.dropdownListWardId.splice(index,1)
            }
           
          }
         
          
        }


        
         
      }
      

      editmessage(){

        this.updateSuccess = false 

      }

      // onChangeVehiclesCategory() {

      //   //console.log();

      //  console.log('790', this.Zname);
      //  this.Wardid   =   this.dropdownListId;

      //  console.log('794',this.Wardid );
       
       
        
      //   if (this.Zname == undefined || this.Zname == null || this.Zname == '') {
      //     //this.edited1 = true;
      //     this.Wardid = undefined;
      //   }
      //   else {
      //     //this.edited1 = false;
      //     this.getWarddata(this.Zname);
      //   }
    
      // }




}


// WEBPACK FOOTER //
// ./src/app/iswmMgt/Location/locations.component.ts